// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleTitle_root__1SxDD","featureOrTwoCol":"ArticleTitle_featureOrTwoCol__2vWY5"};